import ES from './es';
import EN from './en';

const paymentLinks = {
    ES,
    EN
};

export default paymentLinks;
